<template>
    <Delete></Delete>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const Delete = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/EngineeringWorkbench/Delete.vue"
    )
);

export default {
    name: "Project_HelpDelete", //The name you are in should not equal the name of the component you are importing.
    components: { Delete, AuthLayout },
};
</script>
